export class RenewalInfoDataResponse {
    constructor(
        public TermDetails:TermDetails,
        public CoverageDetails:CoverageDetails,
        public LossOfEarnings:LossOfEarnings,
        public ExPatSecurityEvac:ExPatSecurityEvac,
        public TravelSecurityEvac:TravelSecurityEvac,
        public EnhancedExPatSecurityEvac: EnhancedExPatSecurityEvac,       
        public EnhancedTravelSecurityEvac:EnhancedTravelSecurityEvac,
        public ChildAbduction:ChildAbduction,
        public EnhancedChildAbduction:EnhancedChildAbduction,
        public WorkplaceViolence:WorkplaceViolence,
        public ValueOfProducts:ValueOfProducts
    ){ }    
}
export class LossOfEarnings{
    perInsuredEvent: PerInsuredEvent[];
    annualAggregate: AnnualAggregate[];   
  }  
export class TermDetails{
    TermLength: TermLength[];
}
export class TermLength{
    id:number;
    value:string;
}
export class CoverageDetails{
    LimitOfInsurance: LimitOfInsurance[];    
    DisappearanceAndInvestigation: DisappearanceAndInvestigation[];
    ThreatResponse: ThreatResponse[];
    RecallResponse: RecallResponse[];
    Ransom: Ransom[];
    RansomDeductible: RansomDeductible[];
    PersonalBelongings: PersonalBelongings[];
    Transit: Transit[];
    LegalLiability: LegalLiability[];
    AdditionalExpenses: AdditionalExpenses[];
    CrisisResponseFees: CrisisResponseFees[];
    RecallExpenses: RecallExpenses[];
    AaForAllInsuredLosses: AaForAllInsuredLosses[];
    AccidentalDAndDPerInsuredPerson: AccidentalDAndDPerInsuredPerson[];
    AccidentalDAndDPerEvent: AccidentalDAndDPerEvent[];
    ThreatResponseExpense: ThreatResponseExpense[];
    ThreatAnnualAggregate: ThreatAnnualAggregate[];
    DisappearanceInvestigationExpense: DisappearanceInvestigationExpense[];
    DisappearanceAnnualAggregate: DisappearanceAnnualAggregate[];
}


export class LimitOfInsurance{
    id:number;
    value:string;
}
export class DisappearanceAndInvestigation{
    id:number;
    value:string;
}
export class ThreatResponse{
    id:number;
    value:string;
}
export class RecallResponse{
    id:number;
    value:string;
 }
export class Ransom{
   id:number;
   value:string;
}
export class RansomDeductible{
    id:number;
    value:string;
}
//--
export class PersonalBelongings{
    id:number;
    value:string;
}
export class Transit{
    id:number;
    value:string;
}
export class LegalLiability{
    id:number;
    value:string;
}
export class AdditionalExpenses{
    id:number;
    value:string;
 }
export class CrisisResponseFees{
   id:number;
   value:string;
}
export class RecallExpenses{
    id:number;
    value:string;
}
export class AaForAllInsuredLosses{
    id:number;
    value:string;
}
export class AccidentalDAndDPerInsuredPerson{
    id:number;
    value:string;
}
export class AccidentalDAndDPerEvent{
    id:number;
    value:string;
}
export class ThreatResponseExpense{
    id:number;
    value:string;
 }
export class ThreatAnnualAggregate{
   id:number;
   value:string;
}
export class DisappearanceInvestigationExpense{
    id:number;
    value:string;
}
export class DisappearanceAnnualAggregate{
    id:number;
    value:string;
}
export class AnnualAggregate{
    id:number;
    value:string;
}
export class ExPatSecurityEvac{
    perExpatSecurityEvac: PerExpatSecurityEvac[];
    annualAggregate: AnnualAggregate[];
    personalEffects: PersonalEffects[];
    salary: Salary;
    relocationCosts: RelocationCosts[];
    repatriationCosts: RepatriationCosts[];
    unityFeesExpenses: UnityFeesExpenses[];
    excludedCountries:ExcludedCountries[];
  }  
  export class PerExpatSecurityEvac{
    id:string;
    value:string;
  } 
  export class PersonalEffects{
    id:string;
    value:string;
  }
  export class Salary{
    id:string;
    value:string;
  }
  export class RelocationCosts{
    id:string;
    value:string;
  }   
  export class RepatriationCosts{
    id:string;
    value:string;
  }
  export class UnityFeesExpenses{
    id:string;
    value:string;
  }
  export class ExcludedCountries{
    id:string;
    value:string;
  }
  export class TravelSecurityEvac{
    perTravelSecurityEvac:PerTravelSecurityEvac[];
    annualAggregate: AnnualAggregate[];
    personalEffects:PersonalEffects[];
    repatriationCosts: RpatriationCosts[];
    unityFeesExpenses:UnityFeesExpenses[];
    excludedCountries: ExcludedCountries[];  
  } 
  export class PerTravelSecurityEvac{
    id:string;
    value:string;
  } 
  export class RpatriationCosts{
    id:string;
    value:string;
  }
  export class EnhancedExPatSecurityEvac{
    perExpatSecurityEvac:PerExpatSecurityEvac[];
    annualAggregate: AnnualAggregate[];
    personalEffects:PersonalEffects[];
    salary: Salary[];
    relocationCosts:RelocationCosts[];
    repatriationCosts: RepatriationCosts[];
    unityFeesExpenses:UnityFeesExpenses[];
    excludedCountries:ExcludedCountries[];
  }    
  export class EnhancedTravelSecurityEvac{
    perTravelSecurityEvac:PerTravelSecurityEvac[];
    annualAggregate: AnnualAggregate[];
    personalEffects:PersonalEffects[];
    repatriationCosts: RepatriationCosts[];
    unityFeesExpenses:UnityFeesExpenses[];
    excludedCountries: ExcludedCountries[];  
  } 
  export class ChildAbduction{
    perChildAbduction:PerChildAbduction[];
    annualAggregate: AnnualAggregate[];
    Type: Type[];
}
export class Type{
  id:string;
  value:string;
}
  export class PerChildAbduction{
    id:string;
    value:string;
  }
  export class EnhancedChildAbduction{
    perChildAbduction:PerChildAbduction[];
    annualAggregate: AnnualAggregate[];
    legalFees: LegalFees[];
  }
  export class LegalFees{
    id:string;
    value:string;
  }
  export class WorkplaceViolence{
    perWorkplaceViolence:PerWorkplaceViolence[];
    annualAggregate: AnnualAggregate[];
    maxBenefit: MaxBenefit[];
    aggPerWorkplaceViolence: AggPerWorkplaceViolence[];
    death: number;
    lossOfLimb: number;
    lossOfSight: number;
    lossOfSpeech: number;
    permTotalDisability: number;
    mutilation: number;
  }
  export class PerWorkplaceViolence{
    id:string;
    value:string;
  }
  export class MaxBenefit{
    id:string;
    value:string;
  }
  export class AggPerWorkplaceViolence{
    id:string;
    value:string;
  }
  export class ValueOfProducts{
    perInsuredEvent:PerInsuredEvent[];
    annualAggregate: AnnualAggregate[];
}
export class PerInsuredEvent{
    id:string;
    value:string;
  }
  